import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { RouterData } from '@wix/editor-platform-sdk-types'

export const getPageToRouterMap = async ({
  editorSdkProxy,
  routers,
}: {
  editorSdkProxy: EditorSDK
  routers: RouterData[]
}): Promise<Map<{ title: string; pageRef: string }, RouterData>> => {
  const map = new Map()
  for (const router of routers) {
    for (const page of router.pages) {
      const { pageRef } = page
      const pageData = await editorSdkProxy.document.pages.getPageData({
        pageRef: page.pageRef,
      })
      if (!pageData) {
        continue
      }
      const { title } = pageData
      map.set({ title, pageRef }, router)
    }
  }
  return map
}
